import { FunctionComponent } from "react"
import { RootState, useTypedSelector } from "../app/store"

export type Step = {
  name: string
  isActive: boolean
}

// Need this in a separate class because directly interpolating
// the position in the template string doesn't work as Tailwind
// will remove the classes, thinking they are unused.
const lineClasses = (position: "left" | "right") => {
  const classes = `absolute ${position}-1/2 top-0 bottom-0 w-32 h-8 flex items-center justify-center`
  return classes
}

const Line: FunctionComponent<{ position: "left" | "right" }> = ({
  position,
}) => (
  <div className={lineClasses(position)}>
    <div className="bg-gray-200 h-[2px] w-full" />
    <div className="left-1/2 right-1/2"></div>
  </div>
)

const StepDetail: FunctionComponent<{ name: string }> = ({ name }) => (
  <div className="self-stretch flex flex-col items-center justify-start pt-0.5 px-0 pb-0">
    <div className="self-stretch relative leading-[20px] font-semibold text-primary-700 text-sm">
      {name}
    </div>
  </div>
)

export const StepComponent: FunctionComponent = () => {
  const { steps } = useTypedSelector((state: RootState) => {
    return state.simulationSlice
  })
  return (
    <div className="flex flex-row items-center justify-center py-12 px-0 gap-0 relative">
      {steps.map((step: Step, index: number) => (
        <div
          key={index}
          className="relative w-64 h-12 flex flex-col items-center justify-start text-center gap-[12px]">
          {index !== 0 && <Line position="right" />}
          {index !== steps.length - 1 && <Line position="left" />}
          <img
            className="relative rounded-xl w-8 h-8 overflow-hidden shrink-0"
            alt={step.name}
            src={
              step.isActive
                ? "/v3/assets/step_icon_active.svg"
                : "/v3/assets/step_icon.svg"
            }
          />
          <StepDetail name={step.name} />
        </div>
      ))}
    </div>
  )
}
